{
  "actual_edges": [
    {
      "from": "w1",
      "id": "w1-to-w2",
      "kind": "actual",
      "to": "w2"
    },
    {
      "from": "w2",
      "id": "w2-to-w3",
      "kind": "actual",
      "to": "w3"
    },
    {
      "from": "w3",
      "id": "w3-to-w4",
      "kind": "actual",
      "to": "w4"
    },
    {
      "from": "w4",
      "id": "w4-to-w5",
      "kind": "actual",
      "to": "w5"
    },
    {
      "from": "w5",
      "id": "w5-to-w6",
      "kind": "actual",
      "to": "w6"
    },
    {
      "from": "w6",
      "id": "w6-to-w7",
      "kind": "actual",
      "to": "w7"
    },
    {
      "from": "w7",
      "id": "w7-to-w8",
      "kind": "actual",
      "to": "w8"
    },
    {
      "from": "w8",
      "id": "w8-to-w9",
      "kind": "actual",
      "to": "w9"
    },
    {
      "from": "w9",
      "id": "w9-to-w10",
      "kind": "actual",
      "to": "w10"
    },
    {
      "from": "w10",
      "id": "w10-to-w11",
      "kind": "actual",
      "to": "w11"
    },
    {
      "from": "w11",
      "id": "w11-to-w12",
      "kind": "actual",
      "to": "w12"
    },
    {
      "from": "w12",
      "id": "w12-to-w13",
      "kind": "actual",
      "to": "w13"
    },
    {
      "from": "w13",
      "id": "w13-to-w14",
      "kind": "actual",
      "to": "w14"
    },
    {
      "from": "w14",
      "id": "w14-to-w15",
      "kind": "actual",
      "to": "w15"
    },
    {
      "from": "w15",
      "id": "w15-to-w16",
      "kind": "actual",
      "to": "w16"
    },
    {
      "from": "w16",
      "id": "w16-to-w17",
      "kind": "actual",
      "to": "w17"
    },
    {
      "from": "w17",
      "id": "w17-to-w18",
      "kind": "actual",
      "to": "w18"
    },
    {
      "from": "w18",
      "id": "w18-to-w19",
      "kind": "actual",
      "to": "w19"
    }
  ],
  "agent_commit": "c96f2ed3595162a174e680b563337f6215f6eace",
  "branch_semantics": {
    "available_actions": "legal-actions-not-future-state-branches",
    "event_choices": "legal-options-not-executed-unless-selected",
    "projected_counterfactual_states": false
  },
  "campaign_id": "playthrough-evidence-full-v1",
  "cell_id": "visa-seed-42-88dd8348830c",
  "completed_weeks": 19,
  "difficulty": "normal",
  "final_ending": "cashflow_collapse",
  "game_commit": "348b9fd5501e71ebc7142e10f9068fc1490b5124",
  "game_tree": "225cd5451d09bb92da674234a79ecaf8db4beb3a",
  "nodes": [
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_school_germany",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -46,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 19,
        "loneliness": 4,
        "money": -328,
        "social": 5,
        "stress": 7,
        "visa_progress": -2
      },
      "event": {
        "id": "arrival",
        "legal_choices": [
          {
            "choice_id": "arrival.choice_01_先去宿舍放行李",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "energy": 10.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "先去宿舍放行李"
          },
          {
            "choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品",
            "failure_effects": {
              "energy": -6.0,
              "hunger": 6.0,
              "money": -55.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived_supplied",
            "success_effects": {
              "energy": -6.0,
              "hunger": -10.0,
              "money": -55.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "立刻去超市和 dm 补生活用品"
          },
          {
            "choice_id": "arrival.choice_03_先激活_sim_卡和银行_app",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "arrived",
            "success_effects": {
              "language": 1.0,
              "stress": 4.0,
              "visa_progress": 4.0
            },
            "success_rate": 0.746,
            "text": "先激活 SIM 卡和银行 App"
          },
          {
            "choice_id": "arrival.choice_04_坐在车站缓一缓",
            "failure_effects": {
              "money": -25.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "loneliness": 4.0,
              "money": -25.0,
              "stress": -8.0,
              "visa_progress": -2.0
            },
            "success_rate": 1.0,
            "text": "坐在车站缓一缓"
          }
        ],
        "selected_choice_id": "arrival.choice_04_坐在车站缓一缓"
      },
      "evidence": {
        "decision_request_fingerprint": "c72d3cad8cf2b742aa124216e560a92a55425f07dd3240d56bd59726fd195bac",
        "event_request_fingerprint": "e7384b0a1f150d873af587ba937b274e51629281ba07b2eafa5b30cb60dc0de8",
        "source_line": 1,
        "source_record_sha256": "5be1c0e8c87a1a3bb6dd72d6a41283fd8e9dc635add5c2bb20c019f62dbe15e3"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "blocked_account_balance": -992,
        "energy": -46,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 19,
        "loneliness": 4,
        "money": -328,
        "social": 5,
        "stress": 7,
        "unpaid_social_streak": 2,
        "visa_progress": -2,
        "week": 1
      },
      "id": "w1",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 2,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 4 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 84,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 172 EUR，逾期 0 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 58,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_school_germany",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 54,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 37,
        "language": 39,
        "loneliness": 34,
        "money": 172,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 27,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 13,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 10,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 11904,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 100,
        "exam_readiness": 11,
        "failed_courses": 0,
        "flags": {},
        "gpa_score": 61,
        "hunger": 25,
        "language": 20,
        "loneliness": 30,
        "money": 500,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 15,
        "stress": 20,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 0,
        "visa_progress": 15,
        "week": 1,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 1
    },
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 14,
        "energy": -22,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 16,
        "loneliness": 2,
        "money": -172,
        "social": 3,
        "stress": 17,
        "visa_progress": 2
      },
      "event": {
        "id": "germany_language_track_start",
        "legal_choices": [
          {
            "choice_id": "germany_language_track_start.choice_01_报名密集语言班",
            "failure_effects": {
              "language": -1.0,
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "language": 10.0,
              "money": -420.0,
              "stress": 6.0
            },
            "success_rate": 1.0,
            "text": "报名密集语言班"
          },
          {
            "choice_id": "germany_language_track_start.choice_02_先自学一周省钱",
            "failure_effects": {
              "language": -1.0,
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -4.0,
              "language": 4.0,
              "money": 40.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "先自学一周省钱"
          },
          {
            "choice_id": "germany_language_track_start.choice_03_问学校能否条件注册",
            "failure_effects": {
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.521,
            "text": "问学校能否条件注册"
          },
          {
            "choice_id": "germany_language_track_start.choice_04_找便宜语言学校",
            "failure_effects": {
              "language": 2.0,
              "money": -220.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 6.0,
              "money": -260.0,
              "stress": 8.0
            },
            "success_rate": 0.621,
            "text": "找便宜语言学校"
          }
        ],
        "selected_choice_id": "germany_language_track_start.choice_04_找便宜语言学校"
      },
      "evidence": {
        "decision_request_fingerprint": "3365ce026ebf576a9e40265b39fcc05ee0213198f5da952014cb74734bf0fc1b",
        "event_request_fingerprint": "62c90a611a327dbba708eeedcc42c75f9873eb5b04ea1594ad3629f5137dcdbe",
        "source_line": 2,
        "source_record_sha256": "8ce899c10f7e5f1743f556fcfdb90ce828beee47d2e59c90160089978d503d20"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 14,
        "arrears_amount": 343,
        "cash_shortfall_count": 2,
        "energy": -22,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 16,
        "loneliness": 2,
        "money": -172,
        "social": 3,
        "stress": 17,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w2",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 3,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 3 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 91,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 343 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 36,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 343,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 49,
        "language": 55,
        "loneliness": 36,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 44,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 15,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 54,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 37,
        "language": 39,
        "loneliness": 34,
        "money": 172,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 27,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 13,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 2
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 3,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 8,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 39,
        "language": 10,
        "loneliness": 3,
        "social": 1,
        "stress": 28,
        "visa_progress": 2
      },
      "event": {
        "id": "missing_school_registration",
        "legal_choices": [
          {
            "choice_id": "missing_school_registration.choice_02_先找_international_office",
            "failure_effects": {
              "academic_progress": -7.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "school_registered",
            "success_effects": {
              "academic_progress": -3.0,
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.882,
            "text": "先找 International Office"
          },
          {
            "choice_id": "missing_school_registration.choice_03_只靠自学顶一周",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -6.0,
              "hunger": 5.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "只靠自学顶一周"
          },
          {
            "choice_id": "missing_school_registration.choice_04_继续拖延",
            "failure_effects": {
              "money": -80.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -10.0,
              "money": -80.0,
              "stress": 8.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "missing_school_registration.choice_03_只靠自学顶一周"
      },
      "evidence": {
        "decision_request_fingerprint": "6d32ab71a5c0a5c91f6665aa85a000ee93f52c27dfcac7c3bcb57395ba3f5ea4",
        "event_request_fingerprint": "7e2077a2050691475e8bc652e639bde5b443fe1b989fe81679551ff9efa7259a",
        "source_line": 3,
        "source_record_sha256": "27e85e9e7cf937fcd3c0e118e95c43906a937a25c6431f3be9dc26d631ac0643"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 8,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 39,
        "language": 10,
        "loneliness": 3,
        "social": 1,
        "stress": 28,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w3",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 4,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 2 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 98,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 598 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "饥饿 88。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 88,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 44,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 598,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 88,
        "language": 65,
        "loneliness": 39,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 72,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 17,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 36,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 343,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 49,
        "language": 55,
        "loneliness": 36,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 44,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 15,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 3
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [
        "burnout-risk"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 10,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 10,
        "loneliness": 3,
        "money": 120,
        "social": 1,
        "stress": 28,
        "visa_progress": 2
      },
      "event": {
        "id": "wg_interview",
        "legal_choices": [
          {
            "choice_id": "wg_interview.choice_01_表现得非常德式",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "housing_stable",
            "success_effects": {
              "social": 3.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.716,
            "text": "表现得非常德式"
          },
          {
            "choice_id": "wg_interview.choice_02_说自己会做中餐",
            "failure_effects": {
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "wg_cooking",
            "success_effects": {
              "hunger": -6.0,
              "loneliness": -4.0,
              "social": 7.0
            },
            "success_rate": 0.607,
            "text": "说自己会做中餐"
          },
          {
            "choice_id": "wg_interview.choice_03_坦白预算很紧",
            "failure_effects": {
              "social": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "cheap_room_hint",
            "success_effects": {
              "money": 120.0,
              "stress": 5.0
            },
            "success_rate": 0.266,
            "text": "坦白预算很紧"
          },
          {
            "choice_id": "wg_interview.choice_04_过度迎合每条规则",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002
            },
            "set_flag": "housing_stable",
            "success_effects": {
              "energy": -6.0,
              "social": 2.0,
              "stress": 8.0
            },
            "success_rate": 0.411,
            "text": "过度迎合每条规则"
          }
        ],
        "selected_choice_id": "wg_interview.choice_03_坦白预算很紧"
      },
      "evidence": {
        "decision_request_fingerprint": "defbbec28f04cef55ff908b0c2809833e18939fbee72cce7e2524fa7ac63f24b",
        "event_request_fingerprint": "1d4d3fee675252e7b76edaa2f26837cc60c0428324cba3b5f261c31c276e2435",
        "source_line": 4,
        "source_record_sha256": "00de110cdfd29ea8aef97e90893cad6e00879457c647de6818889012cd561a20"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 10,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 10,
        "loneliness": 3,
        "money": 120,
        "social": 1,
        "stress": 28,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w4",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 5,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 1 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 54,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 853,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 75,
        "loneliness": 42,
        "money": 120,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 25,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 19,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 44,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 598,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 88,
        "language": 65,
        "loneliness": 39,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 72,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 17,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 4
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 7,
        "career_progress": 3,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 77,
        "social": 1,
        "visa_progress": 4
      },
      "event": {
        "id": "legal_work_limit_notice",
        "legal_choices": [
          {
            "choice_id": "legal_work_limit_notice.choice_01_把工时记进日历",
            "failure_effects": {
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": 2.0,
              "visa_progress": 3.0
            },
            "success_rate": 1.0,
            "text": "把工时记进日历"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班",
            "failure_effects": {
              "career_progress": -1.0,
              "money": -40.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "career_progress": 3.0,
              "money": -40.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接合同清楚的班"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_03_问_asta/international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "language": 2.0,
              "stress": -1.0,
              "visa_progress": 4.0
            },
            "success_rate": 1.0,
            "text": "问 AStA/International Office"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_04_觉得自己不会超",
            "failure_effects": {
              "stress": 4.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": -2.0
            },
            "success_rate": 0.316,
            "text": "觉得自己不会超"
          }
        ],
        "selected_choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班"
      },
      "evidence": {
        "decision_request_fingerprint": "16687b75e0550742e769e4aaf5228563f2298052207214549417a12f9c06c5f2",
        "event_request_fingerprint": "0169c3d7ecb1b833be3b186a200469fde375583faa48f8909d4ec583879ecc7e",
        "source_line": 5,
        "source_record_sha256": "65703bb2598567c63cbe0cfc5f820cdb257ee19dcbb99636a45226d77473de22"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "career_progress": 3,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 77,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 4,
        "week": 1
      },
      "id": "w5",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 6,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 0 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 61,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 853,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 85,
        "loneliness": 45,
        "money": 197,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 26,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 23,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 54,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 853,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 75,
        "loneliness": 42,
        "money": 120,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 25,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 19,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 5
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [
        "cashflow-stress-attractor"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -197,
        "social": 1,
        "stress": -5,
        "visa_progress": -6
      },
      "event": {
        "id": "anmeldung_deadline",
        "legal_choices": [
          {
            "choice_id": "anmeldung_deadline.choice_01_立刻补材料",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -4.0,
              "stress": 4.0,
              "visa_progress": 7.0
            },
            "success_rate": 1.0,
            "text": "立刻补材料"
          },
          {
            "choice_id": "anmeldung_deadline.choice_02_先问_international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 1.0,
              "stress": -2.0,
              "visa_progress": 5.0
            },
            "success_rate": 1.0,
            "text": "先问 International Office"
          },
          {
            "choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung",
            "failure_effects": {
              "stress": 6.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "social": 3.0,
              "stress": 1.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.842,
            "text": "请室友确认 Wohnungsgeberbestätigung"
          },
          {
            "choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉",
            "failure_effects": {
              "money": -30.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "admin_avoidance",
            "success_effects": {
              "money": -30.0,
              "stress": -5.0,
              "visa_progress": -8.0
            },
            "success_rate": 1.0,
            "text": "把信封塞进抽屉"
          }
        ],
        "selected_choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉"
      },
      "evidence": {
        "decision_request_fingerprint": "bfe5579224249e571a293fe0252e6068ca9ad505cd317ce7bbedb73715c2a1b8",
        "event_request_fingerprint": "e6d90dede2e875fa1406990676d5c01a1aa793f540733b434db0a103478670a0",
        "source_line": 6,
        "source_record_sha256": "0011a5a918e9f58b1412a6e93388e442511527dbb7840a4ee79e408907c1e433"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 88,
        "cash_shortfall_count": 2,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -197,
        "social": 1,
        "stress": -5,
        "unpaid_social_streak": 2,
        "visa_progress": -6,
        "week": 1
      },
      "id": "w6",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 7,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 941 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 95。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 95,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 68,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 941,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 6,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 95,
        "loneliness": 48,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 27,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 17,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 61,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 853,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 85,
        "loneliness": 45,
        "money": 197,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 26,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 23,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 6
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": -5,
        "language": 5,
        "loneliness": 3,
        "social": 1,
        "stress": 5,
        "visa_progress": 4
      },
      "event": {
        "id": "registration_window_missed",
        "legal_choices": [
          {
            "choice_id": "registration_window_missed.choice_01_接受下学期再注册",
            "failure_effects": {
              "money": -650.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -12.0,
              "money": -650.0,
              "stress": 14.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "接受下学期再注册"
          },
          {
            "choice_id": "registration_window_missed.choice_03_转入语言班等待下学期",
            "failure_effects": {
              "language": -1.0,
              "money": -900.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -9.0,
              "language": 8.0,
              "money": -900.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "转入语言班等待下学期"
          },
          {
            "choice_id": "registration_window_missed.choice_04_逃避邮件和截止日",
            "failure_effects": {
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -16.0,
              "hunger": 8.0,
              "money": -420.0,
              "stress": 22.0
            },
            "success_rate": 1.0,
            "text": "逃避邮件和截止日"
          }
        ],
        "selected_choice_id": "registration_window_missed.choice_01_接受下学期再注册"
      },
      "evidence": {
        "decision_request_fingerprint": "f9e3baf377f5540b385c8834c795917194b558cc857f8ae18b1ac0be686966c2",
        "event_request_fingerprint": "10be83a368d432c13467ada41a3dd54117ca7948e260bf2aa73e6e297603f604",
        "source_line": 7,
        "source_record_sha256": "eded46077d00c63a149d418f21b51b2c57b528be27aa810e76d1d859ac2e50cd"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -5,
        "arrears_amount": 905,
        "cash_shortfall_count": 2,
        "language": 5,
        "loneliness": 3,
        "social": 1,
        "stress": 5,
        "unpaid_social_streak": 2,
        "visa_progress": 4,
        "week": 1
      },
      "id": "w7",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 8,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 1846 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 63,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1846,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 51,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 21,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 68,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 941,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 6,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 95,
        "loneliness": 48,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 27,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 17,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 7
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "parents_money_hint",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 8
            },
            "streak_weeks": 6,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 6 consecutive weeks (week=8).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 8
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 7,
        "loneliness": 3,
        "money": 35,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "parents_money_hint",
        "legal_choices": [
          {
            "choice_id": "parents_money_hint.choice_01_做预算表给他们看",
            "failure_effects": {
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 120.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "做预算表给他们看"
          },
          {
            "choice_id": "parents_money_hint.choice_02_先安慰他们",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "先安慰他们"
          },
          {
            "choice_id": "parents_money_hint.choice_03_稳妥处理",
            "failure_effects": {
              "money": 35.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 105.0,
              "stress": 1.0
            },
            "success_rate": 0.412,
            "text": "稳妥处理"
          },
          {
            "choice_id": "parents_money_hint.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 70.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.62,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "parents_money_hint.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "9be18c021b5bd69febd671f4fedecf093cdddc04798bebf60151f4487606086e",
        "event_request_fingerprint": "b8c4c6f401e9cf984a97aacce8613cfea0a2f4d64e09e12974555ce53d4e1f7f",
        "source_line": 8,
        "source_record_sha256": "6a08d1d57522c5fca9cdc9c484067c304701c1329758e0360d1ecb91846e685d"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": 35,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w8",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 9,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 35 EUR，逾期 2101 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 70,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2101,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 54,
        "money": 35,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 23,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 63,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1846,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 51,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 21,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 8
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 9
            },
            "streak_weeks": 7,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 7 consecutive weeks (week=9).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 9
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_registration",
        "legal_choices": [
          {
            "choice_id": "exam_registration.choice_01_马上报名",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 2.0,
              "exam_readiness": 4.0,
              "stress": -3.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "马上报名"
          },
          {
            "choice_id": "exam_registration.choice_02_报名后顺手查考纲",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 1.0,
              "exam_readiness": 7.0,
              "stress": 1.0
            },
            "success_rate": 1.0,
            "text": "报名后顺手查考纲"
          },
          {
            "choice_id": "exam_registration.choice_03_先问同学报名流程",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "exam_registered",
            "success_effects": {
              "exam_readiness": 3.0,
              "social": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.626,
            "text": "先问同学报名流程"
          },
          {
            "choice_id": "exam_registration.choice_04_晚点再说",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -4.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "晚点再说"
          }
        ],
        "selected_choice_id": "exam_registration.choice_04_晚点再说"
      },
      "evidence": {
        "decision_request_fingerprint": "0c87c51c52bcf2700912683061bd9f9aa3356de79de22a3c828e2d518699db4b",
        "event_request_fingerprint": "030ef026e6958d5afcf60b669a703fc3d18523e0830c58ee307336e9f0602792",
        "source_line": 9,
        "source_record_sha256": "19c377200730221ddee2770f372b030481df9c688e5e483ef4b3e9284c017130"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w9",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 10,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 152 EUR，逾期 2101 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 77,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2101,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 57,
        "money": 152,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 30,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 25,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 70,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2101,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 54,
        "money": 35,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 23,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 9
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "midterm_pressure",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 10
            },
            "streak_weeks": 8,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 8 consecutive weeks (week=10).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 10
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 5,
        "energy": 16,
        "exam_readiness": 2,
        "loneliness": 3,
        "money": -152,
        "social": 1,
        "stress": -6,
        "visa_progress": 2
      },
      "event": {
        "id": "midterm_pressure",
        "legal_choices": [
          {
            "choice_id": "midterm_pressure.choice_01_整理学习计划",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 5.0,
              "exam_readiness": 4.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "整理学习计划"
          },
          {
            "choice_id": "midterm_pressure.choice_02_先睡一觉",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -2.0,
              "energy": 16.0,
              "exam_readiness": -2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "先睡一觉"
          },
          {
            "choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业",
            "failure_effects": {
              "academic_progress": -1.0,
              "money": -139.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 7.0,
              "exam_readiness": 5.0,
              "money": -139.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "砍掉一班打工补作业"
          },
          {
            "choice_id": "midterm_pressure.choice_04_靠咖啡硬顶",
            "failure_effects": {
              "academic_progress": -1.0,
              "energy": -12.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 4.0,
              "energy": -12.0,
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "靠咖啡硬顶"
          }
        ],
        "selected_choice_id": "midterm_pressure.choice_02_先睡一觉"
      },
      "evidence": {
        "decision_request_fingerprint": "16a867c96854e3fedf35a3665a3ac7c835371391c5a6b19d017182fb62108450",
        "event_request_fingerprint": "2e019c5e783bd01ae5c91bd6186cfba2647712df5110e8ad08b3284e26f8c758",
        "source_line": 10,
        "source_record_sha256": "f9776ef226a32a09659811068b560dac6c3eb2ba7348da53efce31a6032cb064"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 5,
        "arrears_amount": 103,
        "cash_shortfall_count": 1,
        "energy": 16,
        "exam_readiness": 2,
        "loneliness": 3,
        "money": -152,
        "social": 1,
        "stress": -6,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w10",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 11,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2204 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 94。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 94,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 82,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2204,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 98,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 60,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 94,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 27,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 77,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2101,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 57,
        "money": 152,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 30,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 25,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 10
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wechat_silence",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 11
            },
            "streak_weeks": 9,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 9 consecutive weeks (week=11).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 11
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 7,
        "energy": -16,
        "exam_readiness": 2,
        "loneliness": 3,
        "stress": 6,
        "visa_progress": 2
      },
      "event": {
        "id": "wechat_silence",
        "legal_choices": [
          {
            "choice_id": "wechat_silence.choice_01_写一段真实记录",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -5.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "写一段真实记录"
          },
          {
            "choice_id": "wechat_silence.choice_02_继续潜水",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 2.0,
              "loneliness": 3.0
            },
            "success_rate": 1.0,
            "text": "继续潜水"
          },
          {
            "choice_id": "wechat_silence.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.196,
            "text": "稳妥处理"
          },
          {
            "choice_id": "wechat_silence.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.401,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "wechat_silence.choice_04_寻求帮助"
      },
      "evidence": {
        "decision_request_fingerprint": "a12b2e347c1772e26e5efdd0d1da3836770a585bc6dedeebe939712ae330e625",
        "event_request_fingerprint": "3acc8b08bdf3c0a928800be7c207812e23893b50faa3cc22faa6f21924194692",
        "source_line": 11,
        "source_record_sha256": "7b89b2abb9eabbdec7a311891f6c0e187f3760d0310cb8bfac0017fbbd3aa5e4"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -16,
        "exam_readiness": 2,
        "loneliness": 3,
        "stress": 6,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w11",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 12,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2459 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 89,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2459,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 63,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 29,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 82,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2204,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 98,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 60,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 94,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 27,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 11
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "group_invite",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 12
            },
            "streak_weeks": 10,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 10 consecutive weeks (week=12).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 12
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 4,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "group_invite",
        "legal_choices": [
          {
            "choice_id": "group_invite.choice_01_答应并主动分工",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 6.0,
              "exam_readiness": 4.0,
              "language": 3.0,
              "social": 8.0
            },
            "success_rate": 0.9,
            "text": "答应并主动分工"
          },
          {
            "choice_id": "group_invite.choice_02_只接资料整理的部分",
            "failure_effects": {
              "academic_progress": -1.0,
              "social": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 4.0,
              "exam_readiness": 2.0,
              "social": 3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接资料整理的部分"
          },
          {
            "choice_id": "group_invite.choice_03_请她先解释评分标准",
            "failure_effects": {
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003,
              "social": 0.002
            },
            "set_flag": "anna_group",
            "success_effects": {
              "exam_readiness": 6.0,
              "language": 3.0,
              "social": 5.0
            },
            "success_rate": 0.832,
            "text": "请她先解释评分标准"
          },
          {
            "choice_id": "group_invite.choice_04_委婉拒绝",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "social": -4.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "委婉拒绝"
          }
        ],
        "selected_choice_id": "group_invite.choice_03_请她先解释评分标准"
      },
      "evidence": {
        "decision_request_fingerprint": "1474911455fd3334ced8594fe023c727716d8a281e689167c5d3f90c11b6bfe3",
        "event_request_fingerprint": "e51dfa56cc882980ed279222f96244d357f392780f4577ee9387dd0080d9db0d",
        "source_line": 12,
        "source_record_sha256": "c2d2446ad8abf006375ef7e545db8bd62c496b7c239d1563bf63a76f14e44d1f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 4,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w12",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 13,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2714 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2714,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 66,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 32,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 31,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 89,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2459,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 63,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 29,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 12
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exercise_sheet_warning",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 13
            },
            "streak_weeks": 11,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 11 consecutive weeks (week=13).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 13
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exercise_sheet_warning",
        "legal_choices": [
          {
            "choice_id": "exercise_sheet_warning.choice_01_补三套练习题",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 10.0,
              "stress": 6.0
            },
            "success_rate": 0.775,
            "text": "补三套练习题"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "language": 2.0,
              "stress": 3.0
            },
            "success_rate": 0.756,
            "text": "去 Tutorium 问清楚"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_03_和同学对答案",
            "failure_effects": {
              "exam_readiness": -2.0,
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 6.0,
              "social": 4.0,
              "stress": 2.0
            },
            "success_rate": 0.495,
            "text": "和同学对答案"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_04_先忙别的",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "exam_readiness": -8.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "先忙别的"
          }
        ],
        "selected_choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚"
      },
      "evidence": {
        "decision_request_fingerprint": "4b622bf94fb8ecd10aa876340b03f0e6946c9b3a23340c4166b7772fd1dea214",
        "event_request_fingerprint": "cd59de8e9d573f2f0c921ccadc812e5011d0447d1666334d8dd704cb3d353b1c",
        "source_line": 13,
        "source_record_sha256": "31ed35c65dc21209e2097137acde8b0a2b686a14284e52b55e028899e5cf8402"
      },
      "finished": false,
      "full_numeric_delta": {
        "blocked_account_balance": -992,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w13",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 14,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 2714 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2714,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 69,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 33,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2714,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 66,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 32,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 31,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 13
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 12,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 12 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "visa_progress": 9
      },
      "event": {
        "id": "visa_status_hidden_check",
        "legal_choices": [
          {
            "choice_id": "visa_status_hidden_check.choice_01_立刻联系外管局和学校",
            "failure_effects": {
              "stress": 14.0,
              "visa_progress": -3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "language": 2.0,
              "stress": 9.0,
              "visa_progress": 9.0
            },
            "success_rate": 0.756,
            "text": "立刻联系外管局和学校"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "stress": 7.0,
              "visa_progress": 7.0
            },
            "success_rate": 0.676,
            "text": "补材料并申请 Fiktionsbescheinigung"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_03_只在网页上继续刷_termin",
            "failure_effects": {
              "stress": 16.0,
              "visa_progress": -4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": 10.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.436,
            "text": "只在网页上继续刷 Termin"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_04_相信不会查到自己",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": -2.0,
              "visa_progress": -8.0
            },
            "success_rate": 0.366,
            "text": "相信不会查到自己"
          }
        ],
        "selected_choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung"
      },
      "evidence": {
        "decision_request_fingerprint": "5535f72662e3c5ce2e2f8422626f51c7064284429b169c81225e6008b4640de6",
        "event_request_fingerprint": "7e1664044b5cb01804c26a747dc57672fc0565b5866fd0e6deb7bb01334b7d6c",
        "source_line": 14,
        "source_record_sha256": "75ee4130a97e082095f036fb938cfb8d31a8e74b81893e340046b75b0d701a87"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 9,
        "week": 1
      },
      "id": "w14",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 15,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2852 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2852,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 72,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 42,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2714,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 69,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 33,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 14
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "streak_weeks": 13,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 13 consecutive weeks (week=15).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "loneliness": 8,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "desperate_illegal_work_offer",
        "legal_choices": [
          {
            "choice_id": "desperate_illegal_work_offer.choice_01_找学生会紧急援助",
            "failure_effects": {
              "hunger": -8.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -18.0,
              "money": 120.0,
              "social": 2.0,
              "stress": 6.0
            },
            "success_rate": 0.457,
            "text": "找学生会紧急援助"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_03_向同学或父母借钱",
            "failure_effects": {
              "loneliness": 5.0,
              "stress": 16.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -12.0,
              "loneliness": -3.0,
              "money": 260.0,
              "stress": 9.0
            },
            "success_rate": 0.422,
            "text": "向同学或父母借钱"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_04_接下现金黑工",
            "failure_effects": {
              "energy": -25.0,
              "illegal_work_hours": 14.0,
              "stress": 24.0,
              "visa_progress": -8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "illegal_work_taken",
            "success_effects": {
              "academic_progress": -9.0,
              "energy": -34.0,
              "hunger": -18.0,
              "illegal_work_hours": 36.0,
              "stress": 20.0
            },
            "success_rate": 0.591,
            "text": "接下现金黑工"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂",
            "failure_effects": {
              "hunger": -18.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -34.0,
              "money": 20.0,
              "social": -1.0,
              "stress": 8.0
            },
            "success_rate": 0.617,
            "text": "去食物救助/低价食堂"
          }
        ],
        "selected_choice_id": "desperate_illegal_work_offer.choice_03_向同学或父母借钱"
      },
      "evidence": {
        "decision_request_fingerprint": "e292b90325a089f9a41396f5f6e47c90479efa1f7de9d0d903b77a339c181f27",
        "event_request_fingerprint": "78741d33f9704c70b5db86624f61dcafe8a83a0c2046a2fc2dd3fea5df61d1fc",
        "source_line": 15,
        "source_record_sha256": "1b38c2e392f9f4518e1919a828650448b0c84997ef53bc0908eb8f8b036797d2"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 8,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w15",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 16,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3107 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3107,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 80,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 44,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2852,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 72,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 42,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 15
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "streak_weeks": 14,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 14 consecutive weeks (week=16).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "energy": -4,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "klausur_countdown",
        "legal_choices": [
          {
            "choice_id": "klausur_countdown.choice_01_整理错题清单",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 12.0,
              "stress": 5.0
            },
            "success_rate": 0.462,
            "text": "整理错题清单"
          },
          {
            "choice_id": "klausur_countdown.choice_02_约教授/助教答疑",
            "failure_effects": {
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003,
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 8.0,
              "stress": 3.0
            },
            "success_rate": 0.651,
            "text": "约教授/助教答疑"
          },
          {
            "choice_id": "klausur_countdown.choice_03_和小组模拟考试",
            "failure_effects": {
              "exam_readiness": 1.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 9.0,
              "social": 4.0,
              "stress": 4.0
            },
            "success_rate": 0.52,
            "text": "和小组模拟考试"
          },
          {
            "choice_id": "klausur_countdown.choice_04_继续拖延",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 5.0,
              "exam_readiness": -12.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "klausur_countdown.choice_01_整理错题清单"
      },
      "evidence": {
        "decision_request_fingerprint": "81d92acc315549066fc72ebc538d9d92d59de83b6310129e33b08e13664ec7d0",
        "event_request_fingerprint": "1e9a5a88e4b13da951fe90cea77a222ecb5f5989ff34cbdd638e3bf93496025e",
        "source_line": 16,
        "source_record_sha256": "27ce9609e6d21d46fa5ad84e9c6a81455a35f0c9910a6620448498bb9cdbeb87"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -4,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w16",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 17,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3362 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3362,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 83,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 46,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3107,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 80,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 44,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 16
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "family_compare",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 17
            },
            "streak_weeks": 15,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 15 consecutive weeks (week=17).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 17
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "family_compare",
        "legal_choices": [
          {
            "choice_id": "family_compare.choice_01_少看消息",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": 2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "少看消息"
          },
          {
            "choice_id": "family_compare.choice_02_认真解释自己的节奏",
            "failure_effects": {
              "career_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "career_progress": 2.0,
              "stress": 4.0
            },
            "success_rate": 1.0,
            "text": "认真解释自己的节奏"
          },
          {
            "choice_id": "family_compare.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.192,
            "text": "稳妥处理"
          },
          {
            "choice_id": "family_compare.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.388,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "family_compare.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "b4752cdfc71817bf7f165801d8fd07922b110b18368a0c3d0e3cab4d241d5223",
        "event_request_fingerprint": "9b56b14862176090b60b1d36723428f91fb6dc36b5f17425c78bb3b3c4ce2309",
        "source_line": 17,
        "source_record_sha256": "b2468176b761fbbe1b6c8959fd16e01e284f3364d8b52f72da53816b058710fd"
      },
      "finished": false,
      "full_numeric_delta": {
        "blocked_account_balance": -992,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w17",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 18,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 3362 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3362,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 86,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 48,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3362,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 83,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 46,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 17
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_week",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 18
            },
            "streak_weeks": 16,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 16 consecutive weeks (week=18).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 18
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "exam_readiness": -8,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_week",
        "legal_choices": [
          {
            "choice_id": "exam_week.choice_01_先做会的题",
            "failure_effects": {
              "exam_readiness": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 5.0,
              "stress": 4.0
            },
            "success_rate": 0.432,
            "text": "先做会的题"
          },
          {
            "choice_id": "exam_week.choice_02_硬翻译题目",
            "failure_effects": {
              "exam_readiness": -4.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 2.0,
              "language": 3.0,
              "stress": 7.0
            },
            "success_rate": 0.592,
            "text": "硬翻译题目"
          },
          {
            "choice_id": "exam_week.choice_03_先扫整张卷子分配时间",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.005
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "stress": 2.0
            },
            "success_rate": 0.392,
            "text": "先扫整张卷子分配时间"
          },
          {
            "choice_id": "exam_week.choice_04_盯着第一题死磕",
            "failure_effects": {
              "exam_readiness": -8.0,
              "stress": 14.0
            },
            "next_event_id": "",
            "requirements": {
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -5.0,
              "stress": 10.0
            },
            "success_rate": 0.092,
            "text": "盯着第一题死磕"
          }
        ],
        "selected_choice_id": "exam_week.choice_04_盯着第一题死磕"
      },
      "evidence": {
        "decision_request_fingerprint": "5416b8cf7efc7d4412d50ee06b028bb8eacaf3a5e5fcff38b3caa195a257c129",
        "event_request_fingerprint": "f8b46dc6795765641ba2537edbba0ff54b7ebebe790deb6e5ae4f32fac3c7627",
        "source_line": 18,
        "source_record_sha256": "a7f5bbc9c2104a37141761a3be2021df238ddce7518f2069071c81fd9706eab9"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "exam_readiness": -8,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w18",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 19,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3500 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3500,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 92,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 89,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 50,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3362,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 86,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 48,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 18
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "write_email_practice",
                "problem_set",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "after_exam_void",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 19
            },
            "streak_weeks": 17,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 17 consecutive weeks (week=19).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 19
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise visa priorities"
      },
      "delta": {
        "academic_progress": 3,
        "exam_readiness": 8,
        "loneliness": 3,
        "social": 1,
        "stress": -4,
        "visa_progress": 2
      },
      "event": {
        "id": "after_exam_void",
        "legal_choices": [
          {
            "choice_id": "after_exam_void.choice_01_休息半天",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 12.0,
              "stress": -10.0
            },
            "success_rate": 1.0,
            "text": "休息半天"
          },
          {
            "choice_id": "after_exam_void.choice_02_立刻复盘",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "立刻复盘"
          },
          {
            "choice_id": "after_exam_void.choice_03_稳妥处理",
            "failure_effects": {
              "academic_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.578,
            "text": "稳妥处理"
          },
          {
            "choice_id": "after_exam_void.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.772,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "after_exam_void.choice_02_立刻复盘"
      },
      "evidence": {
        "decision_request_fingerprint": "9b9c8645cb52db53d4d569645c56757309f72f831fd5fadf0321892783325ed2",
        "event_request_fingerprint": "07a9d6a4476f949e03dca5121be46eafcfeb953f265344cab22faf6620e4cf47",
        "source_line": 19,
        "source_record_sha256": "49d9633bbfcb5b01b6b63f27efc3bcda6023d50cbd5e8333251333aa39e03162"
      },
      "finished": true,
      "full_numeric_delta": {
        "academic_progress": 3,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "exam_readiness": 8,
        "loneliness": 3,
        "social": 1,
        "stress": -4,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w19",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 20,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3755 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 96。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 96,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "write_email_practice",
        "problem_set",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 96,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3755,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 17,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 92,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 96,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 38,
        "visa_progress": 52,
        "week": 20,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3500,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 92,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "cheap_room_hint": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 89,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 50,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 19
    }
  ],
  "persona": "visa",
  "provider": "replay",
  "provider_mode": "replay",
  "provider_revision": "fixture:865f4fb83028f7ada18b581462adef3cbb15f2b06ed4c59cb0601f97b0d5f590",
  "scenario": "default_first_semester",
  "schema_version": "playthrough-view-v1",
  "seed": 42,
  "source_trace": {
    "artifact_path": "reports/playthrough-evidence/campaigns/playthrough-evidence-full-v1/cells/visa-seed-42-88dd8348830c/playthrough.jsonl",
    "artifact_sha256": "20b561d0322f3fb78272a4ec49ef294db19e87e5560ec559f171040ade5eecda",
    "record_count": 19
  },
  "stop_reason": "game_finished",
  "truth_label": "prerecorded-real-godot-replay"
}
